import type {
  Action,
  SagaCallbacks,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestCreateAnnouncement = ({
  body,
  callbacks,
}: {
  body: {
    title: string,
    description: string,
  },
  callbacks?: SagaCallbacks,
}): Action => ({
  type: actionTypes.REQUEST_CREATE_ANNOUNCEMENT,
  body,
  callbacks,
});

export const requestDismissAnnouncement = ({
  id,
  callbacks,
}: {
  id: number
  callbacks?: SagaCallbacks,
}): Action => ({
  type: actionTypes.REQUEST_DISMISS_ANNOUNCEMENT,
  id,
  callbacks,
});
